import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getRequestBySlug } from '../lib/api';
import { RequestDetailSkeleton } from './RequestDetailPage';

export default function GigSlugPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    async function resolve() {
      try {
        const res = await getRequestBySlug(slug);
        // Replace current URL so back button works naturally
        navigate(`/requests/${res.data.reference || res.data.id}`, { replace: true });
      } catch {
        setError(true);
      }
    }
    resolve();
  }, [slug, navigate]);

  if (error) {
    return (
      <div className="page-container-lg py-20 text-center">
        <h1 className="hero-title mb-3">Gig Not Found</h1>
        <p className="body-text mb-6">This link may have expired or been removed.</p>
        <button
          onClick={() => navigate('/requests')}
          className="btn-primary px-6 py-2"
          data-testid="browse-gigs-btn"
        >
          Browse open gigs
        </button>
      </div>
    );
  }

  // Resolving the link, then opening the gig: the gig page's own skeleton covers both steps.
  return <RequestDetailSkeleton />;
}
